



























import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
import { IPriceItem } from '~/assets/interfaces/price'
import ComponentPrice from '~/components/price/price.vue'
@Component({
  components: {
    ComponentPrice,
  },
})
export default class ComponentProductDetailPricesLight extends mixins(
  MixinGeneral
) {
  @Prop({ type: Array, default: () => [] }) readonly prices: IPriceItem[]
  @Prop({ type: String, default: null }) readonly unit!: string
  // Раскладка карточки товара: актуальная цена первой строкой, старая — второй
  // и без единицы измерения. Скидку здесь не показываем — она уже есть лейблом
  // поверх картинки.
  @Prop({ type: Boolean, default: false }) readonly card!: boolean
}
